import { Outlet } from 'react-router-dom'

import { Loading } from 'modules/compensations/components/loading'
import { useCyclesListFilterOptions } from 'modules/compensations/hooks/useCyclesListFilterOptions'
import { CyclesList } from 'modules/compensations/pages/CyclesList'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const CyclesPage = () => {
  const {
    countryFilterOptions,
    currencyFilterOptions,
    loading: loadingFilterOptions,
  } = useCyclesListFilterOptions()

  if (loadingFilterOptions) {
    return <Loading />
  }

  return (
    <ResponsivePage.Body height="none">
      <CyclesList
        countryFilterOptions={countryFilterOptions}
        currencyFilterOptions={currencyFilterOptions}
      />
      <Outlet
        context={{
          countryFilterOptions,
          currencyFilterOptions,
        }}
      />{' '}
    </ResponsivePage.Body>
  )
}

export default CyclesPage
